export default __webpack_public_path__ + "static/media/ne.1b87356b.svg";